import { Modal } from 'react-bootstrap';
import classes from './HowGoShareWorksModal.module.css';
import { Calendar, Truck, X } from 'react-feather';
import { Armchair } from 'lucide-react';

const HowNationWideWorksModal = (props) => {
	const { nationWideModal, setNationWideModal } = props;
	return (
		<>
			<Modal show={nationWideModal} onHide={() => setNationWideModal(false)}>
				<div className={classes.main}>
					<X
						strokeWidth={1}
						onClick={() => setNationWideModal(false)}
						className={classes.closeIcon}
					/>
					<h3 className={classes.title1}> Country Wide Shipping with Kashew</h3>

					<p className={classes.infoText1}>
						We offer a comprehensive comparison of shipping rates from over 30
						pre-approved carriers, guaranteeing that you receive the most
						competitive quote possible.
					</p>
					<img
						className={classes.deliveryPic}
						alt={'nation wide delivery available on kashew'}
						src={
							'https://ik.imagekit.io/kuj9zqlrx0or/Static/nationWide.png?tr=h-1000'
						}
					/>

					<div className={classes.deliverySpec}>
						<Armchair className={classes.icon} />
						<h6 className={classes.infoText}>
							Enter your address to discover the most cost-effective and
							efficient option for white glove delivery with full insurance
							coverage throughout the country.
						</h6>
					</div>

					<div className={classes.deliverySpec}>
						<Calendar className={classes.icon} />
						<h6 className={classes.infoText}>
							Send a purchase request or offer for the item. Once the seller
							approves, you will receive a tracking link for the shipment to see
							updates in real-time.
						</h6>
					</div>

					<div className={classes.deliverySpec}>
						<Truck className={classes.icon} />
						<h6 className={classes.infoText}>
							Our team of delivery professionals will take care of the item
							pick-up and bring it all the way to its new spot in your home.
							We&apos;ll make sure you are completely happy with your purchase
							before releasing payment to the seller.
						</h6>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default HowNationWideWorksModal;
